import * as React from 'react';
import './Form.css';
import Button from '@mui/material/Button';

function Form() {
  const sendEmail =(e)=> {
     e.preventDefault();
     alert("Your message send, thankyou for connecting...")
  }

  return (
    <div className="Form-container">
      <h1 className="page__title">Any Query? Drop Your Message here</h1>
      <form className="contact__form" onSubmit={sendEmail}>
        <label htmlFor="emailFrom">Email:</label>
        <input type="text" name="email_from" id="emailFrom" className="email__from" placeholder="person@example.com"/>
        <label htmlFor="message">Message:</label>
        <textarea name="message" id="message" className="message__box"></textarea>
        <Button variant="contained"  className="submit__btn" style={{marginTop: "5px"}}>
        Send
      </Button>
      </form>
    </div>
  );
}

export default Form;